"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const fonts = {
  normal: '"Circular Pro", Arial, sans-serif;',
  book: '"Circular Pro", Arial, sans-serif;',
  black: '"Circular Pro Black", Arial, sans-serif;',
  bold: '"Circular Pro Bold", Arial, sans-serif;'
}; // normal = book

var _default = fonts;
exports.default = _default;